import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen overflow-hidden bg-[#030d2b] text-white">
      <div className="absolute inset-0 bg-[linear-gradient(115deg,#020927_0%,#04123a_45%,#07214b_100%),radial-gradient(circle_at_43%_56%,rgba(111,110,255,0.62),transparent_34%),radial-gradient(circle_at_74%_55%,rgba(56,153,255,0.40),transparent_42%),radial-gradient(circle_at_20%_92%,rgba(42,77,186,0.30),transparent_45%)]" />
      <div className="absolute top-1/2 left-[46%] -translate-x-1/2 -translate-y-1/2 h-[34rem] w-[34rem] rounded-full bg-indigo-500/20 blur-[120px]" />
      <div className="absolute top-[46%] left-[72%] -translate-x-1/2 -translate-y-1/2 h-[28rem] w-[28rem] rounded-full bg-cyan-400/20 blur-[120px]" />

      <main className="relative z-10 min-h-screen">
        <div className="mx-auto w-full max-w-[1450px] px-6 md:px-12 lg:px-20 pt-20 md:pt-28 lg:pt-36 pb-14">
          <h1 className="mt-8 max-w-4xl text-[clamp(2.3rem,6.1vw,5.6rem)] font-semibold tracking-[-0.03em] leading-[0.98]">
            <span className="bg-gradient-to-r from-slate-100 via-slate-200 to-indigo-200 bg-clip-text text-transparent">
              Forja el Futuro Profesional que Sueñas
            </span>
          </h1>

          <p className="mt-7 max-w-3xl text-[clamp(1.02rem,1.5vw,1.45rem)] leading-relaxed text-slate-300/85">
            Creemos en tu potencial. Registra tu hoja de vida y dejanos conectarte con
            oportunidades que transformaran tu trayectoria laboral.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
            <Button
              type="button"
              onClick={() => navigate("/registro")}
              className="h-14 px-8 rounded-full bg-gradient-to-r from-indigo-600 to-indigo-400 hover:from-indigo-500 hover:to-indigo-300 text-white text-base tracking-[0.08em] font-bold uppercase shadow-[0_14px_40px_rgba(81,92,255,0.35)]"
              data-testid="start-registration-button"
            >
              Comenzar Mi Registro
              <ArrowRight className="h-5 w-5 ml-2" />
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
}
